import React from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useGetTimeZones } from "@/services/RegisterCompany";
import { useTranslation } from "react-i18next";

type keyOptions = "value" | "label";

interface SelectPropsExtended extends SelectProps {
  valueKey: keyOptions;
  labelKey: keyOptions;
}

const SelectTimezone: React.FC<SelectPropsExtended> = ({ valueKey, labelKey, ...restProps }) => {
  const { data: timezones, isLoading } = useGetTimeZones();
  const { t } = useTranslation();

  const options = transformDataToSelectOption(timezones || [], valueKey || "value", labelKey || "label", t);

  return <Select data={options} loading={isLoading} {...restProps} />;
};
export default SelectTimezone;
